import { gql } from '@apollo/client';

export const FILTERED_ATTENDANCES = gql`
  query FilteredAttendances($input: SearchData!) {
    attendances: filteredSchoolAttendances(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          absentDays
          absenteeismRate
          actualAttendance
          attendanceRate
          circuit {
            id
            name
          }
          district {
            id
            name
          }
          emisNumber
          grade {
            id
            name
            value
          }
          numberEnrolled
          possibleAttendance
          term
          year
          institution {
            id
            name
          }
        }
      }
    }
  }
`;
